import {
  ROLE_PERMISSION_DICTIONARIES_MANAGEMENT,
  ROLE_PERMISSION_USER_MANAGEMENT,
  ROLE_PERMISSION_VEHICLE_MANAGEMENT,
  ROLE_PERMISSION_ISSUE_CREATE,
  ROLE_PERMISSION_SERVICE_REPORT_CREATE,
  ROLE_PERMISSION_SERVICE_REPORT_EDIT,
  ROLE_PERMISSION_REVIEW_REPORT_CREATE,
  ROLE_PERMISSION_REVIEW_REPORT_EDIT,
  ROLE_PERMISSION_COMPREHENSIVE_REPORT_GENERATE,
  ROLE_PERMISSION_SPARE_PART_VIEW
} from "../common/permissions";
import i18n from "@/common/lang.serivce";

export default [
  {
    path: "*",
    meta: {
      public: true
    },
    redirect: {
      path: "/404"
    }
  },
  {
    path: "/404",
    meta: {
      public: true
    },
    name: "NotFound",
    component: () =>
      import(
        /* webpackChunkName: "routes" */
        `@/views/NotFound.vue`
      )
  },
  {
    path: "/403",
    meta: {
      public: true
    },
    name: "AccessDenied",
    component: () =>
      import(
        /* webpackChunkName: "routes" */
        `@/views/Deny.vue`
      )
  },
  {
    path: "/500",
    meta: {
      public: true
    },
    name: "ServerError",
    component: () =>
      import(
        /* webpackChunkName: "routes" */
        `@/views/Error.vue`
      )
  },
  {
    path: "/login",
    meta: {
      public: true
    },
    name: "Login",
    component: () =>
      import(
        /* webpackChunkName: "routes" */
        `@/views/Login.vue`
      )
  },
  {
    path: "/",
    meta: {},
    name: "Root",
    redirect: {
      name: "Dashboard"
    }
  },
  {
    path: "/dashboard",
    meta: {
      breadcrumb: true,
      title: i18n.t("dashboard.name"),
      icon: "dashboard"
    },
    name: "Dashboard",
    component: () =>
      import(
        /* webpackChunkName: "routes" */
        `@/views/Dashboard.vue`
      )
  },
  {
    path: "/users",
    meta: {
      title: i18n.t("users"),
      icon: "people",
      breadcrumb: true,
      addButton: {
        allowed: true,
        tooltip: i18n.t("createUserTooltip")
      },
      permission: ROLE_PERMISSION_USER_MANAGEMENT
    },
    name: "Users",
    component: () =>
      import(
        /* webpackChunkName: "routes" */
        `@/views/User/UsersList.vue`
      )
  },
  {
    path: "/vehicles",
    meta: {
      title: i18n.t("vehicles"),
      icon: "train",
      breadcrumb: true,
      addButton: {
        allowed: true,
        permission: ROLE_PERMISSION_VEHICLE_MANAGEMENT,
        tooltip: i18n.t("createVehicleTooltip")
      },
      autoRefresh: true
    },
    name: "Vehicles",
    component: () =>
      import(
        /* webpackChunkName: "routes" */
        `@/views/Vehicle/VehiclesList.vue`
      )
  },
  {
    path: "/fault-messages",
    meta: {
      title: i18n.t("faultMessages"),
      breadcrumb: true,
      addButton: {
        allowed: true
      },
      permission: ROLE_PERMISSION_DICTIONARIES_MANAGEMENT
    },
    name: "FaultMessages",
    component: () =>
      import(
        /* webpackChunkName: "routes" */
        `@/views/FaultMessages/FaultMessagesList.vue`
      )
  },
  {
    path: "/issues",
    meta: {
      title: i18n.t("issues"),
      icon: "bug_report",
      breadcrumb: true,
      addButton: {
        allowed: true,
        permission: ROLE_PERMISSION_ISSUE_CREATE,
        tooltip: i18n.t("createIssueTooltip")
      }
    },
    name: "Issues",
    component: () =>
      import(
        /* webpackChunkName: "routes" */
        `@/views/Issue/IssuesList.vue`
      )
  },
  {
    path: "/issues/:id",
    name: "IssueShow",
    component: () =>
      import(
        /* webpackChunkName: "routes" */
        `@/views/Issue/IssueShow.vue`
      ),
    props: true
  },
  {
    path: "/dictionary/components",
    meta: {
      title: i18n.t("components"),
      breadcrumb: true,
      addButton: {
        allowed: true
      },
      permission: ROLE_PERMISSION_DICTIONARIES_MANAGEMENT
    },
    name: "DictionaryComponents",
    component: () =>
      import(
        /* webpackChunkName: "routes" */
        `@/views/Dictionary/Component/ComponentsList.vue`
      )
  },
  {
    path: "/service-reports",
    meta: {
      title: i18n.t("serviceReports"),
      icon: "build",
      breadcrumb: true,
      addButton: {
        allowed: true,
        permission: ROLE_PERMISSION_SERVICE_REPORT_CREATE,
        tooltip: i18n.t("createServiceReportTooltip")
      }
    },
    name: "ServiceReports",
    component: () =>
      import(
        /* webpackChunkName: "routes" */
        `@/views/ServiceReport/ServiceReportsList.vue`
      )
  },
  {
    path: "/service-reports/create",
    meta: {
      permission: ROLE_PERMISSION_SERVICE_REPORT_CREATE
    },
    name: "ServiceReportCreate",
    component: () =>
      import(
        /* webpackChunkName: "routes" */
        `@/views/ServiceReport/ServiceReportsCreate.vue`
      )
  },
  {
    path: "/service-reports/edit/:id",
    meta: {
      permission: ROLE_PERMISSION_SERVICE_REPORT_EDIT
    },
    name: "ServiceReportEdit",
    component: () =>
      import(
        /* webpackChunkName: "routes" */
        `@/views/ServiceReport/ServiceReportsCreate.vue`
      ),
    props: true
  },
  {
    path: "/service-reports/create/issue/:issueId",
    meta: {
      permission: ROLE_PERMISSION_SERVICE_REPORT_CREATE
    },
    name: "ServiceReportCreateWithIssue",
    component: () =>
      import(
        /* webpackChunkName: "routes" */
        `@/views/ServiceReport/ServiceReportsCreate.vue`
      ),
    props: true
  },
  {
    path: "/service-reports/:id",
    name: "ServiceReportShow",
    component: () =>
      import(
        /* webpackChunkName: "routes" */
        `@/views/ServiceReport/ServiceReportShow.vue`
      ),
    props: true
  },
  {
    path: "/review-reports",
    meta: {
      title: i18n.t("reviewReports"),
      icon: "assignment",
      breadcrumb: true,
      addButton: {
        allowed: true,
        permission: ROLE_PERMISSION_REVIEW_REPORT_CREATE,
        tooltip: i18n.t("createReviewReportTooltip")
      }
    },
    name: "ReviewReports",
    component: () =>
      import(
        /* webpackChunkName: "routes" */
        `@/views/ReviewReport/ReviewReportsList.vue`
      )
  },
  {
    path: "/review-reports/:id",
    name: "ReviewReportShow",
    component: () =>
      import(
        /* webpackChunkName: "routes" */
        `@/views/ReviewReport/ReviewReportShow.vue`
      ),
    props: true
  },
  {
    path: "/review-reports/create",
    meta: {
      permission: ROLE_PERMISSION_REVIEW_REPORT_CREATE
    },
    name: "ReviewReportCreate",
    component: () =>
      import(
        /* webpackChunkName: "routes" */
        `@/views/ReviewReport/ReviewReportsCreate.vue`
      )
  },
  {
    path: "/review-reports/edit/:id",
    meta: {
      permission: ROLE_PERMISSION_REVIEW_REPORT_EDIT
    },
    name: "ReviewReportEdit",
    component: () =>
      import(
        /* webpackChunkName: "routes" */
        `@/views/ReviewReport/ReviewReportsCreate.vue`
      ),
    props: true
  },
  {
    path: "/reports/basic",
    meta: {
      title: i18n.t("menu.basicReport"),
      icon: "timeline",
      hideRefreshButton: true
    },
    name: "BasicReport",
    component: () =>
      import(
        /* webpackChunkName: "routes" */
        `@/views/Report/BasicReport.vue`
      )
  },
  {
    path: "/reports/detailed",
    meta: {
      title: i18n.t("menu.detailedReport"),
      icon: "timeline",
      hideRefreshButton: true
    },
    name: "DetailedReport",
    component: () =>
      import(
        /* webpackChunkName: "routes" */
        `@/views/Report/DetailedReport.vue`
      )
  },
  {
    path: "/reports/issues",
    meta: {
      title: i18n.t("menu.issuesReport"),
      icon: "timeline",
      hideRefreshButton: true
    },
    name: "IssuesReport",
    component: () =>
      import(
        /* webpackChunkName: "routes" */
        `@/views/Report/IssuesReport.vue`
      )
  },
  {
    path: "/reports/comprehensive",
    meta: {
      title: i18n.t("menu.comprehensiveReport"),
      icon: "timeline",
      permission: ROLE_PERMISSION_COMPREHENSIVE_REPORT_GENERATE,
      hideRefreshButton: true
    },
    name: "ComprehensiveReport",
    component: () =>
      import(
        /* webpackChunkName: "routes" */
        `@/views/Report/ComprehensiveReport.vue`
      )
  },
  {
    path: "/reports/spare-part",
    meta: {
      title: i18n.t("menu.sparePartReport"),
      icon: "memory",
      permission: ROLE_PERMISSION_SPARE_PART_VIEW,
      hideRefreshButton: true
    },
    name: "SparePartReport",
    component: () =>
      import(
        /* webpackChunkName: "routes" */
        `@/views/Report/SparePartReport.vue`
      )
  },
  {
    path: "/reports/coefficient-readiness",
    meta: {
      title: i18n.t("menu.coefficientReadinessReport"),
      icon: "square_foot",
      hideRefreshButton: true
    },
    name: "CoefficientReadinessList",
    component: () =>
      import(
        /* webpackChunkName: "routes" */
        `@/views/Coefficient/CoefficientReadinessList.vue`
      )
  },
  {
    path: "/reports/coefficient-reliability",
    meta: {
      title: i18n.t("menu.coefficientReliabilityReport"),
      icon: "square_foot",
      hideRefreshButton: true
    },
    name: "CoefficientReliabilityList",
    component: () =>
      import(
        /* webpackChunkName: "routes" */
        `@/views/Coefficient/CoefficientReliabilityList.vue`
      )
  },
  {
    path: "/dictionary/spare-part-types",
    meta: {
      title: i18n.t("sparePartTypes"),
      breadcrumb: true,
      addButton: {
        allowed: true
      },
      permission: ROLE_PERMISSION_DICTIONARIES_MANAGEMENT
    },
    name: "DictionarySparePartTypes",
    component: () =>
      import(
        /* webpackChunkName: "routes" */
        `@/views/SparePart/SparePartTypesList.vue`
      )
  },




  {
    path: "/dictionary/fleets",
    meta: {
      title: i18n.t("fleets"),
      breadcrumb: true,
      addButton: {
        allowed: true
      },
      permission: ROLE_PERMISSION_DICTIONARIES_MANAGEMENT
    },
    name: "Fleets",
    component: () =>
      import(
        /* webpackChunkName: "routes" */
        `@/views/Fleets.vue`
      )
  },



  {
    path: "/spare-parts",
    meta: {
      title: i18n.t("spareParts"),
      breadcrumb: true,
      icon: "memory",
      addButton: {
        allowed: true
      },
      permission: ROLE_PERMISSION_DICTIONARIES_MANAGEMENT
    },
    name: "SpareParts",
    component: () =>
      import(
        /* webpackChunkName: "routes" */
        `@/views/SparePart/SparePartsList.vue`
      )
  },
  {
    path: "/vehicles/:vehicleId/spare-parts",
    meta: {
      permission: ROLE_PERMISSION_SPARE_PART_VIEW
    },
    name: "VehicleSpareParts",
    component: () =>
      import(
        /* webpackChunkName: "routes" */
        `@/views/Vehicle/VehiclesSparePartsList.vue`
      ),
    props: true
  }
];
